<template>
  <div class="nav-switcher">

    <b-navbar-nav class="ml-auto">
      <b-nav-item-dropdown>
        <template slot="button-content">
          <img :src="icons[currentLocale]" class="country-icon as-toggle" />
        </template>
        <div @click="localeChange">
          <router-link  v-for="locale in locales" :key="locale.code" :to="`/${locale.code}/`+ currentSubRoute" class="dropdown-item">
            <img  :src="icons[locale.code]" class="country-icon" />
            <span class="locale-name">{{locale.name}}</span>
          </router-link>
        </div>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </div>
</template>

<script>
import {
  locales
} from "../config/i18n";
export default {
  data() {
    return {
      icons: {
        en: "/static/svg/flags/us.svg",
        es: "/static/svg/flags/es.svg",
        pt: "/static/svg/flags/pt.svg",
        xx: "/static/svg/flags/xx.svg"
      },
      locales
    };
  },
  components: {
  },
  computed: {
    currentLocale() {
      // return this.$route.params.locale
      return localStorage.getItem("locale");
    },
    currentSubRoute() {
      // TODO: Check for locale in route first...
      var subroute = this.$route.fullPath.substring(4);
      return subroute;
    }
  },
  methods:{
    localeChange: function () {
      return location.reload();
    }
  },
  mounted: function() {

  }
};
</script>

<style>
  .country-icon {
    width: 22px;
    height: auto;
    display: inline-block;
    vertical-align: baseline;
    border: 1px solid #dee2e6;
    box-shadow: 0px 1px 3px rgba(24, 29, 38, 0.1);
  }

  .country-icon.as-toggle {
    margin-top: 6px;
  }

  .locale-name {
    display: inline-block;
    vertical-align: baseline;
  }
</style>
